$('.variant_image').each(function() {
    // var srcimg = $(this).data('src');
    $('.variant_image_to[data-place="' + $(this).data('place') + '"]').attr( "src" , $(this).data('src') );
   // $('.variant_image_to[data-place="' + $(this).data('place') + '"]').attr( "alt" , $(this).data('alt') );
    $('.swatch_set[data-place="' + $(this).data('place') + '"]').attr( "data-inventory" , $(this).data('inventory') );
    });
    $( "input.pick-option" ).on( "click", function() {
    $( ".variant_onchange" ).html( $( "input:checked" ).val() );
    });
     $('#video__thumbnail').click(function(){
        $(this).hide().siblings('#campusvideo').show();
        $('#campusvideo').get(0).play();
     }); 
     $(".multicolumn-card").click(function(e) {
        $(this).find("a")[0].click();
    }); 
    $(".multicolumn-card a").click(function(e) {
        e.stopPropagation();
    });
  //   $(window).on('load', function () {
  //   $('.cookie-settings-header').attr('tabindex', '0');
  // });
    $("#information li:last").after('<li class="cookies_prefrences"><button onclick="showPreferences(this);" class="isense-reopen-widget-link link link--text list-menu__item list-menu__item--link" tabindex="0" aria-haspopup="dialog" style="cursor: pointer;">Cookie Preferences</button></li>');
    //$( ".header__menu-item:contains('Shop by School')" ).prepend('<div aria-hidden="true" class="main_badge"><span aria-hidden="true" class="new__badge">New!</span></div>');
    $( ".header__menu-item:contains('Shop by School')" ).prepend('<div class="main_badge"><span class="visually-hidden">New School Added!</span><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 326.2 181.2" style="enable-background:new 0 0 326.2 181.2;" xml:space="preserve"><g><path fill="#B0191A" d="M8,4.7C6.3,6.4,6.3,132.6,8,134.3c0.9,0.9,7.3,1.2,22.7,1.2h21.6l20.5,21c11.3,11.6,21,21,21.7,21   c0.6,0,1.9-0.7,2.7-1.6c1.3-1.3,1.6-4.5,1.6-19.8c0-12.8,0.4-18.6,1.2-19.4c0.9-0.9,26.7-1.2,109.8-1.2s108.9-0.3,109.8-1.2   c1.7-1.7,1.7-127.9,0-129.6C317.9,3,9.7,3,8,4.7z"/><g><path fill="#FFFFFF" d="M108.1,34.8v67.6H92.8L68.4,66.9H68v35.5H49.6V34.8h15.6l24,35.4h0.5V34.8H108.1z"/><path fill="#FFFFFF" d="M120.6,102.5V34.8h48.8v14.8h-30.4v11.6h27.9v14.8h-27.9v11.6h30.3v14.8H120.6z"/><path fill="#FFFFFF" d="M199.3,102.5l-20-67.6h20.5l9.2,41.6h0.5l11-41.6h16.1l11,41.8h0.5l9.2-41.8H278l-20,67.6h-17.6l-11.5-37.8    h-0.5l-11.5,37.8H199.3z"/></g></g></svg></div>');
    $( "strong.grandchildlink:contains('Popular')" ).prepend('<span aria-hidden="true" class="hot_prod"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"/></svg></span>');
    $('.readmore').click(function (event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.collection-full__description');
        descriptionFull.style.display = 'block';
        descriptionFull.setAttribute('tabindex', '-1');
        descriptionFull.focus();
        var descriptionShort = document.querySelector('.collection-short__description');
        descriptionShort.style.display = 'none';
        descriptionShort.setAttribute('tabindex', '-1');
        descriptionShort.focus();
      });
      $('.readless').click(function (event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.collection-full__description');
        descriptionFull.style.display = 'none';
        descriptionFull.setAttribute('tabindex', '-1');
        descriptionFull.focus();
        var descriptionShort = document.querySelector('.collection-short__description');
        descriptionShort.style.display = 'block';
        descriptionShort.setAttribute('tabindex', '-1');
        descriptionShort.focus();
      }); 
      $("#transcript").click(function() {
        $(this).toggleClass('open')
      $(this).attr('aria-expanded',$(this).attr('aria-expanded')==='true'?'false':'true' );
    }); 
    $('a').filter('[target="_blank"]').attr('aria-describedby', 'a11y-new-window-message');
   
  window.onload = function(){
    setInterval(function(){
      $('#insta-feed a').filter('[target="_blank"]').attr('aria-describedby', 'a11y-new-window-message');
    }, 5000);
 };
//discount__timer
// var today = new Date();
// var tomorrow = new Date();
// tomorrow.setDate(tomorrow.getDate() + 1);
// tomorrow.setHours(0,0,0,0);
// var diffMs = (tomorrow - today); // milliseconds between now & Christmas
// var minutes = Math.floor((diffMs/1000)/60);
// countdown( minutes );
// function countdown(  minutes ) {
//   var target_date = new Date().getTime() + ((minutes * 60 ) * 1000); // set the countdown date
//   var time_limit = ((minutes * 60 ) * 1000);
//   var days, hours, minutes, seconds; // variables for time units
//   var countdown = document.getElementById("tiles"); // get tag element
//   getCountdown();
//   setInterval(function () { getCountdown(); }, 1000);
//   function getCountdown(){
//     var current_date = new Date().getTime();
//     var seconds_left = (target_date - current_date) / 1000;

//   if ( seconds_left >= 0 ) {
//     console.log(time_limit);
//      if ( (seconds_left * 1000 ) < ( time_limit / 2 ) )  {
//        $( '#tiles' ).removeClass('color-full');
//        $( '#tiles' ).addClass('color-half');

//       } 
//       if ( (seconds_left * 1000 ) < ( time_limit / 4 ) )  {
//         $( '#tiles' ).removeClass('color-half');
//         $( '#tiles' ).addClass('color-empty');
//       }

//     days = pad( parseInt(seconds_left / 86400) );
//     seconds_left = seconds_left % 86400;

//     hours = pad( parseInt(seconds_left / 3600) );
//     seconds_left = seconds_left % 3600;

//     minutes = pad( parseInt(seconds_left / 60) );
//     seconds = pad( parseInt( seconds_left % 60 ) );
//     countdown.innerHTML = "<span>" + hours + "<span class='time-ch'>h</span>:</span><span>" + minutes + "<span class='time-ch'>m</span>:</span><span>" + seconds + "<span class='time-ch'>s</span></span>"; 
//   }
//   }
//   function pad(n) {
//     return (n < 10 ? '0' : '') + n;
// 	}
// };
//discount_counter_end
// $(".field__input").on('focus blur', function(){
//   $(this).prev('label.field__label').toggleClass('is_focused');
// })
$( document ).ready(function() {
  var existCondition = setInterval(function() {
  if ($('.notifyjs-corner').length) { 
  clearInterval(existCondition);
  runMyFunction2();
  }
  }, 1000);
  function runMyFunction2(){
    $('.notifyjs-corner').attr('role', 'status');
    $('.notifyjs-corner').attr('aria-live', 'polite');
  }
  }); 
  jQuery(document).ready(function ($) {
    let count = $("#school_list li").length;
    $("#school-result").text(count);
  }); 
  //recent product code
  $( document ).ready(function() {
    var existCondition = setInterval(function() {
    if ($('.recently-viewed-grid').length) { 
    clearInterval(existCondition);
    runMyFunction2();
    }
    }, 1000);
    function runMyFunction2(){
      $('.recently-viewed-grid li:first-child .h5:empty').parent().closest('.recently-viewed-wrapper').hide();
      $('a.recently-viewed-a[href=""]').closest('li').addClass('empty-grid').empty();
    }
    }); 
   $('a').filter('[target="_blank"]').append('<span class="visually-hidden" style="color:black;background:white;">(opens new window)</span>');
      //Accessibility Improvments for Klaviyo form 
      $(document).ready(function() {
        $(document).on('click', '.go3894874857', function(event) {
            setTimeout(function() {
                $('.needsclick>form').focus();
            }, 2000);
        });
    });
    $(document).ready(function () {
      function checkWindowWidth() {
        if ($(window).width() <= 1000) {
          $('.skip__nav').attr('href', '#Details-menu-drawer-container')
        }
      }
        checkWindowWidth();
        $(window).on('resize', checkWindowWidth);
    });
    $(document).ready(function() {
      $('#shopify-installments-cta').click(function(event) {
          event.stopPropagation();
          $('body').addClass('new');
          // Your code to set focus
          $('#shopify-payment-terms-modal').focus();
  
          // Other actions you want to perform on this click event
          // ...
      });
  });
  // Code for Prop 65 Warnings 
$(document).ready(function() {
  $('.prop-warning-btn').on('click', function() {
    // Toggle open class on the button
    $(this).toggleClass('open');
    // Toggle open class on the associated content
    $('.prop-warning-content').toggleClass('open');

    // Check current aria-expanded value and toggle it
    var isExpanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !isExpanded);

    // Optionally, also toggle aria-expanded for the content if needed
    // $('.prop-warning-content').attr('aria-expanded', !isExpanded);
  });
});
  
//     $(document).ready(function() {
//       $('#shopify-installments-cta').click(function() {
//         $('#shopify-payment-terms-modal').addClass('open');
//           $('#shopify-payment-terms-modal').focus();
//           $('#shopify-payment-terms-cover').addClass('open');
//           $('body').addClass('new');
//       });
//   });
//   $('#shopify-installments-cta').on('click', function() {
//     setTimeout(function() {
//         $('#shopify-payment-terms-modal').focus();
//     }, 1000); // Adjust the timeout as necessary
// });
// $( document ).ready(function() {
//   var existCondition = setInterval(function() {
//   if ($('#shopify-payment-terms-modal').length) { 
//   clearInterval(existCondition);
//   runMyFunction();
//   }
//   }, 100);
//   function runMyFunction(){
//     $('#shopify-payment-terms-cover').attr('tabindex', '-1').attr('aria-label', 'Installment Popup').focus();
//   }
//   }); 
document.addEventListener("DOMContentLoaded", function() {
  // Check if the success message exists
  var successMessage = document.getElementById("success-message");
  if (successMessage) {
    // Wait for 1 second before setting the focus
    setTimeout(function() {
      successMessage.focus();
    }, 2000);
  }
});

// custom_js_start
$("br").attr("aria-hidden","true");
$("a[href='https://www.acu.edu/']").attr("target","_balnk");
$("a[href='https://www.acu.edu/']").append('<span class="visually-hidden" style="color:black;background:white;">(opens new window)</span>');
$("a[href='https://campuswardrobe.goaffpro.com/']").attr("target","_balnk");
$("a[href='https://campuswardrobe.goaffpro.com/']").append('<span class="visually-hidden" style="color:black;background:white;">(opens new window)</span>');
$(".sweats_set .multicolumn-card__info h3").attr('aria-level','2');
// custom_js_end
